var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgToiletPaper = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#222830",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.21 7.22h-1.49V.33c0-.41-.34-.75-.75-.75H2.83c-.41 0-.75.34-.75.75v6.89H.8c-.41 0-.75.34-.75.75s.34.75.75.75h1.28v6.89c0 .41.34.75.75.75h.34v5.2c0 .22.09.42.25.56s.37.2.59.18c.02 0 2.22-.28 4.13-.28 1.13 0 2.52.19 3.87.37 1.24.16 2.41.32 3.29.32 2.09 0 4.69-.39 4.8-.41.37-.05.64-.37.64-.74v-5.2h.22c.41 0 .75-.34.75-.75V8.72h1.49c.41 0 .75-.34.75-.75s-.34-.75-.75-.75zM3.58 1.08h16.64v13.79H3.58zm15.68 19.83c-.89.11-2.56.3-3.94.3-.79 0-1.91-.15-3.1-.31-1.4-.19-2.84-.38-4.07-.38s-2.63.11-3.48.2v-4.36h14.58v4.54z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.07 3.75h-2.2c-.41 0-.75.34-.75.75s.34.75.75.75h2.2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75M12.98 3.75h-2.2c-.41 0-.75.34-.75.75s.34.75.75.75h2.2a.749.749 0 1 0 0-1.5M17.88 3.75h-2.2c-.41 0-.75.34-.75.75s.34.75.75.75h2.2c.41 0 .75-.34.75-.75s-.34-.75-.75-.75"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgToiletPaper;